import {ReportFilterBase} from './reportFilterBase';

export class ReportFilterByDate extends ReportFilterBase {

    minDate:string;

    maxDate:string;

}
